import ApiService from './api';

const K2Settings = {
  
  // Neuer Code: Liefert den aktuellen K2-Modus via ApiService
  getMode: async function(botId) {
    try {
      const response = await ApiService.get('/schaltzentrale/k2/k2mode/' + botId);
      return response.data.mode;
    } catch (error) {
      return 'unknown';
    }
  },

  // Neuer Code: Aktualisiert den K2-Modus via ApiService und gibt den neuen Modus zurück
  updateMode: async function(botId, mode) {
    console.log('updateMode', botId, mode);
    try {
      const response = await ApiService.post('/schaltzentrale/k2/k2mode/' + botId, { mode });
      console.log('updateMode response', response);
      return response.data.mode;
    } catch (error) {
      throw error;
    }
  },
}

export default K2Settings;